import API from '../config/api';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
// import {
//   Link
// } from "react-router-dom";
import axios from 'axios';

/* Charms strung along the toran, in the order they repeat. Mango leaves sit
   between the ornaments the way a real garland is tied, and each hangs on its
   own length of thread so the row reads as strung rather than stuck on. */
const TORAN_CHARMS = [
  { icon: '🌼', drop: 7 },
  { icon: '🍃', drop: 15 },
  { icon: '🔔', drop: 10 },
  { icon: '🍃', drop: 17 },
  { icon: '🪔', drop: 8 },
  { icon: '🍃', drop: 14 },
  { icon: '🕉️', drop: 11 },
  { icon: '🍃', drop: 16 },
  { icon: '🪷', drop: 8 },
  { icon: '🍃', drop: 15 },
  { icon: '🌻', drop: 10 },
  { icon: '🍃', drop: 17 },
  { icon: '🥥', drop: 9 },
  { icon: '🍃', drop: 14 },
  { icon: '⭐', drop: 12 },
  { icon: '🍃', drop: 16 },
  { icon: '🌺', drop: 8 }
];

/* Charms strung down the vertical ropes on either edge of the card */
const VINE_LEFT = ['🌼', '🍃', '🪔', '🍃', '🕉️', '🍃', '🪷', '🍃', '🌺'];
const VINE_RIGHT = ['🍃', '🌻', '🍃', '🪔', '🍃', '⭐', '🍃', '🌼'];

function HeroSection() {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  const [timeLeft, setTimeLeft] = useState(0);
  const [imgIndex, setImgIndex] = useState(0);
  const navigate = useNavigate();

  const heroProduct = offers[0];

  // Countdown Timer
  // Countdown Timer
  // Fetch Top Sale Products
  // Fetch Top Sale Products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const { data } = await axios.get(`${API}/products`);

        const heroProduct = data.find(
          (product) => product.heroProduct === true
        );

        if (heroProduct) {
          setOffers([heroProduct]);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  // Professional Countdown Timer
  useEffect(() => {
    let saleEndTime = localStorage.getItem('saleEndTime');

    if (!saleEndTime) {
      saleEndTime = Date.now() + 60 * 60 * 1000;

      localStorage.setItem('saleEndTime', saleEndTime);
    }

    const timer = setInterval(() => {
      const remainingTime = Math.floor(
        (Number(saleEndTime) - Date.now()) / 1000
      );

      if (remainingTime <= 0) {
        const newEndTime = Date.now() + 60 * 60 * 1000;

        localStorage.setItem('saleEndTime', newEndTime);

        saleEndTime = newEndTime;

        setTimeLeft(3600);
      } else {
        setTimeLeft(remainingTime);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Auto Slide Products — rotate the hero image every 5 seconds
  const heroImages =
    heroProduct?.images && heroProduct.images.length > 0
      ? heroProduct.images
      : heroProduct
        ? [heroProduct.image]
        : [];

  useEffect(() => {
    if (heroImages.length <= 1) return;

    const slide = setInterval(() => {
      setImgIndex((prev) => (prev + 1) % heroImages.length);
    }, 5000);

    return () => clearInterval(slide);
  }, [heroImages.length]);

  // Timer Values
  const hours = Math.floor(timeLeft / 3600);

  const minutes = Math.floor((timeLeft % 3600) / 60);

  const seconds = timeLeft % 60;

  // No product is marked as the mega-sale hero — hide the section entirely
  if (!loading && !heroProduct) {
    return null;
  }

  // Loading State — skeleton that mirrors the real hero layout
  if (!heroProduct) {
    return (
      <Container fluid className="py-4 py-md-5 px-md-5 px-3 hero-section">
        <style>{heroStyles}</style>

        <Card
          className="hero-card border-0 shadow-lg overflow-hidden"
          style={{ borderRadius: '30px' }}
        >
          <span className="hero-blob hero-blob-1" />
          <span className="hero-blob hero-blob-2" />

          <Row className="align-items-center g-0 position-relative">
            <Col
              lg={6}
              className="p-4 p-md-5 text-center text-lg-start order-2 order-lg-1 hero-left"
            >
              <div className="hero-skel hero-skel-pill" />
              <div className="hero-skel hero-skel-title" />
              <div className="hero-skel hero-skel-title short" />
              <div className="hero-skel hero-skel-text" />

              <div className="d-flex flex-wrap gap-2 gap-md-3 my-4 justify-content-center justify-content-lg-start">
                {[0, 1, 2].map((n) => (
                  <div key={n} className="hero-skel hero-skel-timer" />
                ))}
              </div>

              <div className="d-flex flex-wrap gap-3 justify-content-center justify-content-lg-start">
                <div className="hero-skel hero-skel-btn" />
                <div className="hero-skel hero-skel-btn" />
              </div>
            </Col>

            <Col
              lg={6}
              className="text-center position-relative p-4 p-md-5 order-1 order-lg-2"
            >
              <div className="hero-skel hero-skel-img" />
            </Col>
          </Row>
        </Card>
      </Container>
    );
  }
  return (
    <Container fluid className="py-4 py-md-5 px-md-5 px-3 hero-section">
      <style>{heroStyles}</style>

      <Card
        className="hero-card border-0 shadow-lg overflow-hidden"
        style={{ borderRadius: '30px' }}
      >
        {/* Decorative glow blobs */}
        <span className="hero-blob hero-blob-1" />
        <span className="hero-blob hero-blob-2" />

        <span className="hero-grid" />

        {/* Sacred syllable watermark */}
        <span className="hero-om" aria-hidden="true">
          ॐ
        </span>

        {/* Drifting decorations — the bag and diamond were removed */}
        <span className="hero-deco hero-deco-1">✨</span>

        {/* Toran — a marigold garland strung across the top, swaying */}
        <span className="hero-toran" aria-hidden="true">
          {TORAN_CHARMS.map((charm, i) => (
            <span
              className="hero-toran-hang"
              key={i}
              style={{
                /* dip the middle of the garland to follow the thread */
                marginTop: `${Math.round(
                  Math.sin((i / (TORAN_CHARMS.length - 1)) * Math.PI) * 11
                )}px`,
                animationDelay: `${(i * 0.17).toFixed(2)}s`
              }}
            >
              <span className="hero-toran-bead" />
              <span
                className="hero-toran-string"
                style={{ height: `${charm.drop}px` }}
              />
              <span className="hero-toran-charm">{charm.icon}</span>
            </span>
          ))}
        </span>

        {/* Vertical ropes down both edges, charms tied along them */}
        <span className="hero-vine hero-vine-left" aria-hidden="true">
          {VINE_LEFT.map((icon, i) => (
            <span
              className="hero-vine-item"
              key={i}
              style={{ animationDelay: `${(i * 0.21).toFixed(2)}s` }}
            >
              <span className="hero-vine-bead" />
              <span className="hero-vine-charm">{icon}</span>
            </span>
          ))}
        </span>

        <span className="hero-vine hero-vine-right" aria-hidden="true">
          {/* Temple bell hangs at the top of the right rope */}
          <span className="hero-vine-item is-bell">
            <span className="hero-vine-bead" />
            <span className="hero-bell">🔔</span>
          </span>

          {VINE_RIGHT.map((icon, i) => (
            <span
              className="hero-vine-item"
              key={i}
              style={{ animationDelay: `${(i * 0.19 + 0.4).toFixed(2)}s` }}
            >
              <span className="hero-vine-bead" />
              <span className="hero-vine-charm">{icon}</span>
            </span>
          ))}
        </span>

        {/* Festival string lights chasing along the base */}
        <span className="hero-lights" aria-hidden="true">
          {Array.from({ length: 24 }).map((_, i) => (
            <span
              className="hero-light"
              key={i}
              style={{ animationDelay: `${(i * 0.11).toFixed(2)}s` }}
            />
          ))}
        </span>

        <Row className="align-items-center g-0 position-relative">
          {/* Left Section */}
          <Col
            lg={6}
            className="p-4 p-md-5 text-center text-lg-start order-2 order-lg-1 hero-left"
          >
            <span className="hero-pill px-4 py-2 rounded-pill">
              <span className="hero-pulse-dot" />
              🕉️ SACRED COLLECTION LIVE
            </span>

            <h1
              className="fw-bold mt-4 hero-title"
              style={{
                fontSize: 'clamp(2.2rem, 5vw, 4.5rem)',
                lineHeight: '1.15'
              }}
            >
              Divine &amp; Spiritual
              <br />
              <span className="hero-gradient-text">Collection</span>
            </h1>

            <h3 className="mt-3 fw-bold hero-product-name">
              {heroProduct.name}
            </h3>

            <p className="lead mt-3 hero-product-desc">
              {heroProduct.shortDescription}
            </p>

            {/* Timer */}
            <div className="d-flex flex-wrap gap-2 gap-md-3 my-4 justify-content-center justify-content-lg-start">
              {[
                { value: hours, label: 'Hours' },
                { value: minutes, label: 'Minutes' },
                { value: seconds, label: 'Seconds' }
              ].map((item, index) => (
                <React.Fragment key={index}>
                  {index > 0 && (
                    <span className="hero-colon align-self-center">:</span>
                  )}
                  <div className="hero-timer-box text-center p-2 p-md-3">
                    <h2 className="fw-bold hero-accent mb-0">
                      {String(item.value).padStart(2, '0')}
                    </h2>
                    <small>{item.label}</small>
                  </div>
                </React.Fragment>
              ))}
            </div>

            {/* Buttons */}
            <div className="d-flex flex-wrap gap-3 justify-content-center justify-content-lg-start">
              <Button
                size="lg"
                className="hero-btn-primary"
                onClick={() => navigate(`/product/${heroProduct._id}`)}
              >
                Shop Now →
              </Button>

              <Button
                variant="outline-dark"
                size="lg"
                className="hero-btn-outline"
                onClick={() => navigate('/products')}
              >
                Explore Collection
              </Button>
            </div>

            {/* Stats */}
            <div className="d-flex flex-wrap gap-4 mt-5 justify-content-center justify-content-lg-start">
              <div>
                <h4 className="fw-bold hero-accent mb-0">500+</h4>
                <small>Sacred Items</small>
              </div>
              <div>
                <h4 className="fw-bold hero-accent mb-0">20K+</h4>
                <small>Devotees</small>
              </div>
              <div>
                <h4 className="fw-bold hero-accent mb-0">4.9★</h4>
                <small>Blessings</small>
              </div>
            </div>
          </Col>

          {/* Right Section */}
          <Col
            lg={6}
            className="text-center position-relative p-4 p-md-5 order-1 order-lg-2"
          >
            {/* Discount Badge */}
            <div className="hero-discount-badge">
              50%
              <br />
              OFF
            </div>

            {/* Product Image (auto-rotating) */}
            <div className="hero-img-wrap">
              <img
                key={imgIndex}
                src={heroImages[imgIndex % heroImages.length]}
                alt={heroProduct.name}
                className="img-fluid hero-img"
                onClick={() => navigate(`/product/${heroProduct._id}`)}
              />

              {heroImages.length > 1 && (
                <div className="hero-dots">
                  {heroImages.map((_, i) => (
                    <button
                      key={i}
                      type="button"
                      className={
                        'hero-dot ' +
                        (i === imgIndex % heroImages.length ? 'active' : '')
                      }
                      onClick={() => setImgIndex(i)}
                      aria-label={`Show image ${i + 1}`}
                    />
                  ))}
                </div>
              )}
            </div>

            {/* Floating Badge */}
            <Card className="hero-float-badge border-0 shadow">
              <Card.Body className="py-3">
                <h6 className="fw-bold mb-1">🚚 Free Delivery</h6>
                <small className="text-muted">On orders above ₹999</small>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Card>
    </Container>
  );
}

const heroStyles = `
  /* Divine backdrop framing the hero card */
  .hero-section {
    background:
      radial-gradient(760px 340px at 10% -10%, rgba(124,58,237,0.14), transparent 70%),
      radial-gradient(760px 340px at 90% 110%, rgba(234,88,12,0.16), transparent 70%),
      linear-gradient(135deg, #faf5ff 0%, #fff7ed 50%, #fef3c7 100%);
  }

  /* Night-temple palette: indigo dusk → deep maroon → burnt saffron.
     The gradient pans slowly, exactly like the category hero. */
  .hero-card {
    position: relative;
    background: linear-gradient(120deg, #150a1f, #2e0a16 30%, #4a1005 58%, #7c2d12 80%, #b45309);
    background-size: 220% 220%;
    animation: heroDrift 14s ease-in-out infinite;
    border: 1px solid rgba(253, 230, 138, 0.28) !important;
    box-shadow: 0 30px 70px rgba(20, 6, 2, 0.55) !important;
  }
  @keyframes heroDrift {
    0%, 100% { background-position: 0% 50%; }
    50%      { background-position: 100% 50%; }
  }

  .hero-blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(70px);
    opacity: 0.5;
    pointer-events: none;
    z-index: 0;
  }
  .hero-blob-1 {
    width: 320px; height: 320px;
    background: #f59e0b;
    top: -120px; left: -80px;
    opacity: 0.35;
    animation: heroBlob 9s ease-in-out infinite;
  }
  .hero-blob-2 {
    width: 280px; height: 280px;
    background: #38bdf8;
    bottom: -120px; right: -60px;
    opacity: 0.35;
    animation: heroBlob 11s ease-in-out infinite reverse;
  }
  @keyframes heroBlob {
    0%, 100% { transform: translate(0,0) scale(1); }
    50%      { transform: translate(24px, 16px) scale(1.15); }
  }

  /* Faint grid for depth */
  .hero-grid {
    position: absolute;
    inset: 0;
    z-index: 0;
    background-image: linear-gradient(rgba(255,255,255,0.07) 1px, transparent 1px),
                      linear-gradient(90deg, rgba(255,255,255,0.07) 1px, transparent 1px);
    background-size: 46px 46px;
    -webkit-mask-image: radial-gradient(circle at 50% 40%, #000, transparent 72%);
    mask-image: radial-gradient(circle at 50% 40%, #000, transparent 72%);
    pointer-events: none;
  }

  /* Drifting decorations */
  .hero-deco {
    position: absolute;
    z-index: 1;
    font-size: 1.5rem;
    opacity: 0.55;
    pointer-events: none;
    animation: heroDeco 7s ease-in-out infinite;
  }
  .hero-deco-1 { top: 22%; left: 9%; animation-delay: -1s; }
  @keyframes heroDeco {
    0%, 100% { transform: translateY(0) rotate(-8deg); opacity: 0.35; }
    50%      { transform: translateY(-18px) rotate(8deg); opacity: 0.8; }
  }

  /* ===== Divine trimmings ===== */

  /* Toran garland — pendants hang from a curved thread and sway */
  .hero-toran {
    position: absolute;
    top: 0; left: 0; right: 0;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0 18px;
    z-index: 2;
    pointer-events: none;
  }
  /* The rope itself — a gold cord with a soft glow */
  .hero-toran::before {
    content: '';
    position: absolute;
    left: 3%; right: 3%;
    top: -16px;
    height: 30px;
    border-bottom: 3px solid rgba(253, 230, 138, 0.6);
    border-radius: 0 0 50% 50% / 0 0 100% 100%;
    box-shadow: 0 3px 12px rgba(251, 191, 36, 0.35);
  }
  .hero-toran-hang {
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1;
    transform-origin: 50% 0;
    filter: drop-shadow(0 3px 5px rgba(0, 0, 0, 0.28));
    animation: heroSway 3.4s ease-in-out infinite;
  }
  /* Gold bead where the charm is tied onto the rope */
  .hero-toran-bead {
    width: 5px; height: 5px;
    border-radius: 50%;
    background: radial-gradient(circle at 35% 30%, #fffbeb, #fbbf24 60%, #b45309);
    box-shadow: 0 0 6px rgba(251, 191, 36, 0.8);
  }
  /* Thread each charm dangles from */
  .hero-toran-string {
    width: 1px;
    background: linear-gradient(180deg, rgba(253, 230, 138, 0.75), rgba(253, 230, 138, 0.25));
  }
  .hero-toran-charm { font-size: 0.95rem; }
  @keyframes heroSway {
    0%, 100% { transform: rotate(-8deg); }
    50%      { transform: rotate(8deg); }
  }

  /* Vertical ropes down the left and right edges */
  .hero-vine {
    position: absolute;
    top: 30px; bottom: 30px;
    width: 20px;
    z-index: 2;
    pointer-events: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
  .hero-vine-left  { left: 8px; }
  .hero-vine-right { right: 8px; }
  /* The cord itself, fading out at both ends */
  .hero-vine::before {
    content: '';
    position: absolute;
    top: 0; bottom: 0; left: 50%;
    width: 3px;
    margin-left: -1.5px;
    border-radius: 3px;
    background: linear-gradient(180deg,
      rgba(253,230,138,0.12), rgba(253,230,138,0.6) 10%,
      rgba(253,230,138,0.6) 90%, rgba(253,230,138,0.12));
    box-shadow: 0 0 12px rgba(251, 191, 36, 0.3);
  }
  .hero-vine-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    transform-origin: 50% 0;
    filter: drop-shadow(0 3px 5px rgba(0, 0, 0, 0.3));
    animation: heroVineSway 3.8s ease-in-out infinite;
  }
  .hero-vine-item.is-bell { animation: none; }
  .hero-vine-bead {
    width: 5px; height: 5px;
    border-radius: 50%;
    background: radial-gradient(circle at 35% 30%, #fffbeb, #fbbf24 60%, #b45309);
    box-shadow: 0 0 6px rgba(251, 191, 36, 0.8);
  }
  .hero-vine-charm {
    font-size: 0.9rem;
    line-height: 1;
    margin-top: 3px;
  }
  @keyframes heroVineSway {
    0%, 100% { transform: rotate(-6deg); }
    50%      { transform: rotate(6deg); }
  }

  /* Temple bell — still, then a burst of rings that damp out */
  .hero-bell {
    display: block;
    margin-top: 2px;
    font-size: 1.4rem;
    line-height: 1;
    transform-origin: 50% 0;
    animation: heroBellRing 7.5s ease-in-out infinite;
  }
  @keyframes heroBellRing {
    0%, 60%, 100% { transform: rotate(0deg); }
    64% { transform: rotate(17deg); }
    68% { transform: rotate(-14deg); }
    72% { transform: rotate(10deg); }
    76% { transform: rotate(-7deg); }
    80% { transform: rotate(4deg); }
    85% { transform: rotate(-2deg); }
  }

  /* Serial lights — one glow travelling along the row */
  .hero-lights {
    position: absolute;
    left: 0; right: 0; bottom: 12px;
    display: flex;
    justify-content: space-between;
    padding: 0 26px;
    z-index: 2;
    pointer-events: none;
  }
  .hero-light {
    width: 6px; height: 6px;
    border-radius: 50%;
    background: rgba(253, 230, 138, 0.22);
    animation: heroChase 2.8s ease-in-out infinite;
  }
  @keyframes heroChase {
    0%, 62%, 100% {
      background: rgba(253, 230, 138, 0.22);
      box-shadow: none;
      transform: scale(1);
    }
    31% {
      background: #fde68a;
      box-shadow: 0 0 12px rgba(251, 191, 36, 0.95);
      transform: scale(1.55);
    }
  }

  /* ॐ watermark behind the copy */
  .hero-om {
    position: absolute;
    left: 1.5%;
    top: 50%;
    z-index: 0;
    pointer-events: none;
    font-size: clamp(9rem, 22vw, 19rem);
    line-height: 1;
    font-weight: 700;
    color: rgba(253, 230, 138, 0.09);
    transform: translateY(-50%);
  }

  /* Gold-on-dark type */
  .hero-left { color: #f5e6c8; }
  .hero-accent { color: #fbbf24 !important; }
  .hero-left small { color: rgba(245, 230, 200, 0.68); }
  .hero-product-name {
    color: #fde68a;
    text-shadow: 0 3px 14px rgba(0, 0, 0, 0.5);
  }
  .hero-product-desc { color: rgba(245, 230, 200, 0.78); }

  .hero-pill {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: linear-gradient(135deg, #7c2d12, #c2410c);
    color: #fde68a;
    border: 1px solid rgba(253,230,138,0.5);
    font-weight: 700;
    font-size: 14px;
    letter-spacing: 0.5px;
    box-shadow: 0 8px 22px rgba(194,65,12,0.45);
  }
  .hero-pulse-dot {
    width: 9px; height: 9px;
    background: #dc2626;
    border-radius: 50%;
    display: inline-block;
    box-shadow: 0 0 8px rgba(220, 38, 38, 0.8);
  }

  .hero-gradient-text {
    background: linear-gradient(100deg, #fff 20%, #fde68a 42%, #fff 62%);
    background-size: 220% auto;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: heroShine 6s linear infinite;
  }
  @keyframes heroShine {
    to { background-position: 220% center; }
  }

  .hero-timer-box {
    background: rgba(255,255,255,0.07);
    backdrop-filter: blur(10px);
    border-radius: 15px;
    min-width: 80px;
    border: 1px solid rgba(253,230,138,0.3);
    transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
  }
  .hero-timer-box small { color: rgba(245,230,200,0.7); }
  .hero-timer-box:hover {
    transform: translateY(-4px);
    border-color: rgba(253,230,138,0.65);
    box-shadow: 0 12px 26px rgba(251,191,36,0.28);
  }
  .hero-colon {
    color: #fbbf24;
    font-size: 1.8rem;
    font-weight: 700;
  }

  .hero-btn-primary {
    position: relative;
    overflow: hidden;
    background: #fbbf24;
    border: none;
    color: #111827;
    font-weight: 700;
    border-radius: 50px;
    padding: 12px 32px;
    transition: transform 0.25s ease, box-shadow 0.25s ease;
    box-shadow: 0 10px 25px rgba(251,191,36,0.4);
  }
  .hero-btn-primary:hover {
    background: #f59e0b;
    color: #111827;
    transform: translateY(-3px);
    box-shadow: 0 16px 32px rgba(251,191,36,0.55);
  }
  .hero-btn-outline {
    border-radius: 50px;
    padding: 12px 32px;
    color: #fde68a !important;
    border: 1px solid rgba(253,230,138,0.55) !important;
    background: rgba(255,255,255,0.06) !important;
    backdrop-filter: blur(6px);
    transition: transform 0.25s ease, background 0.25s ease, border-color 0.25s ease;
  }
  .hero-btn-outline:hover {
    transform: translateY(-3px);
    background: rgba(253,230,138,0.16) !important;
    border-color: #fde68a !important;
    color: #fff7ed !important;
  }

  .hero-img-wrap {
    position: relative;
    display: inline-block;
    width: 100%;
  }
  .hero-img {
    max-height: 450px;
    width: 100%;
    object-fit: cover;
    border-radius: 25px;
    box-shadow: 0 25px 50px rgba(0,0,0,0.4);
    transition: transform 0.5s ease, box-shadow 0.5s ease;
    cursor: pointer;
  }
  .hero-img:hover {
    transform: scale(1.04);
    box-shadow: 0 35px 60px rgba(0,0,0,0.55);
  }

  /* Slideshow dots */
  .hero-dots {
    position: absolute;
    bottom: 14px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 8px;
    z-index: 3;
  }
  .hero-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: none;
    padding: 0;
    background: rgba(255,255,255,0.5);
    cursor: pointer;
    transition: background 0.2s ease, transform 0.2s ease;
  }
  .hero-dot.active {
    background: #fbbf24;
    transform: scale(1.25);
  }

  .hero-discount-badge {
    position: absolute;
    top: 28px; right: 28px;
    width: 90px; height: 90px;
    background: linear-gradient(135deg,#ef4444,#dc2626);
    color: #fff;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 18px;
    line-height: 1.1;
    z-index: 2;
    box-shadow: 0 10px 25px rgba(0,0,0,0.3);
    border: 2px solid rgba(253, 230, 138, 0.55);
  }

  .hero-float-badge {
    position: absolute;
    bottom: 28px; left: 28px;
    border-radius: 15px;
    background: rgba(21, 10, 31, 0.72) !important;
    border: 1px solid rgba(253,230,138,0.35) !important;
    backdrop-filter: blur(10px);
    color: #fde68a;
    width: 210px;
    max-width: calc(100% - 56px);
  }
  .hero-float-badge .text-muted {
    color: rgba(245, 230, 200, 0.65) !important;
  }


  @media (max-width: 575.98px) {
    .hero-discount-badge { width: 64px; height: 64px; font-size: 13px; top: 16px; right: 16px; }
    .hero-float-badge { width: 170px; bottom: 16px; left: 16px; }
    .hero-float-badge h6 { font-size: 0.85rem; }
    .hero-timer-box { min-width: 64px; }
  }

  /* Loading skeleton (mirrors the real hero) */
  .hero-skel {
    background: linear-gradient(90deg, rgba(253,230,138,0.07) 25%, rgba(253,230,138,0.24) 37%, rgba(253,230,138,0.07) 63%);
    background-size: 400% 100%;
    animation: heroShimmer 1.5s ease infinite;
    border-radius: 12px;
  }
  .hero-skel-pill { width: 220px; height: 38px; border-radius: 50px; margin: 0 auto 26px; }
  .hero-skel-title { width: 100%; max-width: 420px; height: 46px; margin: 0 auto 14px; }
  .hero-skel-title.short { width: 60%; max-width: 260px; }
  .hero-skel-text { width: 90%; max-width: 380px; height: 18px; margin: 22px auto 0; }
  .hero-skel-timer { width: 80px; height: 84px; border-radius: 15px; }
  .hero-skel-btn { width: 170px; height: 52px; border-radius: 50px; }
  .hero-skel-img { width: 100%; height: clamp(280px, 40vw, 450px); border-radius: 25px; }
  @media (min-width: 992px) {
    .hero-left .hero-skel-pill,
    .hero-left .hero-skel-title,
    .hero-left .hero-skel-text { margin-left: 0; margin-right: 0; }
    .hero-left .hero-skel-title.short { width: 45%; }
  }
  @keyframes heroShimmer {
    0% { background-position: 100% 0; }
    100% { background-position: -100% 0; }
  }
  @media (max-width: 575.98px) {
    .hero-om { font-size: 11rem; }
    .hero-deco { display: none; }
    /* Thin the garland and lights out so they don't crowd a narrow card */
    .hero-toran-hang:nth-child(even) { display: none; }
    .hero-light:nth-child(even) { display: none; }
    /* The side ropes would run into the discount badge on a narrow card */
    .hero-vine { display: none; }
  }

  @media (prefers-reduced-motion: reduce) {
    .hero-skel, .hero-card, .hero-blob-1, .hero-blob-2, .hero-deco,
    .hero-gradient-text, .hero-toran-hang, .hero-bell, .hero-light,
    .hero-vine-item {
      animation: none;
    }
    .hero-gradient-text { -webkit-text-fill-color: #fde68a; }
  }
`;

export default HeroSection;
